var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-header", class: { line: _vm.line } },
    [
      _vm._t("title", function () {
        return [
          _c("h1", {
            staticClass: "title",
            domProps: { textContent: _vm._s(_vm.title) },
          }),
        ]
      }),
      _c("div", { staticClass: "actions" }, [_vm._t("default")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }